;
import { NotFoundComponent } from './not-found/not-found.component'
import { BrowserModule } from '@angular/platform-browser';
import { HttpClientModule } from '@angular/common/http';
import { FormsModule } from '@angular/forms';
import { NgSelectModule } from '@ng-select/ng-select';
import { SweetAlert2Module } from '@sweetalert2/ngx-sweetalert2';
import { NgxMaskDirective, NgxMaskPipe, provideNgxMask } from 'ngx-mask';
import { AppRoutingModule } from './app-routing.module';
import { AppComponent } from './app.component';
import { ComponentsModule } from './components/components.module';
import { RegistrationFormComponent } from './registration-form/registration-form.component';
import { NgModule } from '@angular/core';
import { ReserveUpdateFormComponent } from './reserve-update-form/reserve-update-form.component';

@NgModule({
  declarations: [AppComponent, RegistrationFormComponent, ReserveUpdateFormComponent, NotFoundComponent],
  imports: [
    BrowserModule,
    AppRoutingModule,
    ComponentsModule,
    NgxMaskDirective,
    NgxMaskPipe,
    HttpClientModule,
    NgSelectModule,
    FormsModule,
    SweetAlert2Module.forRoot(),
  ],
  providers: [provideNgxMask()],
  bootstrap: [AppComponent],
})
export class AppModule {}
